/** @jsx jsx */
import { Flex, jsx } from 'theme-ui'
import PropTypes from 'prop-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { options } from './richTextRenderOptions'
import { useEffect } from 'react'

const ScrollToSection = ({ data }) => {
  //Scroll elements into view automatically on page load when there's ?section=SectionName in the URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const sectionParam = urlParams.get('section')
    if (sectionParam) {
      const pageSection = document.getElementById(sectionParam)
      if (pageSection) {
        pageSection.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [])

  const { richTextBody, htmlId } = data.fields
  return (
    <Flex>
      <Flex
        id={htmlId}
        sx={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          maxWidth: 1156,
          width: '100%',
        }}
      >
        {documentToReactComponents(richTextBody, options)}
      </Flex>
    </Flex>
  )
}

ScrollToSection.propTypes = {
  data: PropTypes.object.isRequired,
}
export default ScrollToSection
